import { render, staticRenderFns } from "./privateRefundList.vue?vue&type=template&id=7e83c980&scoped=true&"
import script from "./privateRefundList.vue?vue&type=script&lang=js&"
export * from "./privateRefundList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e83c980",
  null
  
)

export default component.exports